<app-painel-lateral
    [tituloPainel]="'Participação Eleitoral'"
    [descricaoPainel]="'Votantes, não votantes e justificados por UF no pleito selecionado.'"
    [iconePainel]="'pi pi-check-square'"
    [filtrosTemplate]="filtros"
    [conteudoTemplate]="conteudo"
    [ocultarFiltros]="drillAtivo"
>
</app-painel-lateral>

<ng-template #filtros>
    <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">Pleito</span>
        <p-select [options]="pleitoOpcoes" [(ngModel)]="pleitoSelecionado" optionLabel="label" optionValue="idPleito" [placeholder]="'Selecione o pleito'" appendTo="body"></p-select>
    </label>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">UF do estado</span>
        <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
    </label>
    <p-button label="Aplicar" icon="pi pi-search" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    @if (drillAtivo) {
        <app-detalhamento-pendencias
            [indicador]="obterIndicadorDrill()"
            [linhas]="votantesLinhas"
            [first]="firstVotantes"
            [rows]="rowsVotantes"
            [totalRecords]="totalVotantes"
            [carregando]="carregandoVotantes"
            [rotuloVoltar]="'Voltar à participação'"
            [colunaSituacao]="''"
            [voltarNoCard]="true"
            (voltar)="voltarParaParticipacao()"
            (paginaAlterada)="onPageChangeVotantes($event)"
        >
            <section detalhamento-acoes class="drill-filtros-card">
                <div class="drill-filtros-card-header">
                    <span class="drill-filtros-card-icon"><i class="pi pi-filter"></i></span>
                    <h3 class="drill-filtros-card-title">Categoria</h3>
                </div>
                <div class="drill-tabs">
                    @for (tipo of tiposParticipacao; track tipo.codigo) {
                        <p-button [label]="tipo.label" size="small" [outlined]="drillTipo !== tipo.codigo" (onClick)="onTipoDrillChange(tipo.codigo)"></p-button>
                    }
                </div>
            </section>
        </app-detalhamento-pendencias>
    } @else {
        @if (!carregando && participacao.length > 1) {
            <div class="card-entrada card-entrada-1 resumo-card">
                <app-card-content [border]="false" [title]="'Brasil'" [subtitle]="participacao.length + ' UFs no pleito selecionado'" icon="pi pi-flag">
                    <div class="resumo-linha">
                        <div class="resumo-kpi">
                            <span class="resumo-pct">{{ percentualParticipacao(totais) }}</span>
                            <span class="resumo-pct-label">participação</span>
                        </div>
                        <div class="barra-segmentada resumo-barra" aria-hidden="true">
                            <div class="seg seg-v" [style.width.%]="segmento(totais.votantes, totais.total)"></div>
                            <div class="seg seg-n" [style.width.%]="segmento(totais.naoVotantes, totais.total)"></div>
                            <div class="seg seg-j" [style.width.%]="segmento(totais.justificados, totais.total)"></div>
                        </div>
                        <div class="resumo-stats">
                            <button type="button" class="stat stat-v" (click)="abrirDrill(undefined, 'V')">
                                <span class="pontinho"></span>
                                <span class="stat-num">{{ totais.votantes | number }}</span>
                                <span class="stat-lbl">votantes</span>
                            </button>
                            <button type="button" class="stat stat-n" (click)="abrirDrill(undefined, 'N')">
                                <span class="pontinho"></span>
                                <span class="stat-num">{{ totais.naoVotantes | number }}</span>
                                <span class="stat-lbl">não votantes</span>
                            </button>
                            <button type="button" class="stat stat-j" (click)="abrirDrill(undefined, 'J')">
                                <span class="pontinho"></span>
                                <span class="stat-num">{{ totais.justificados | number }}</span>
                                <span class="stat-lbl">justificados</span>
                            </button>
                            <span class="stat stat-total">
                                <span class="stat-num">{{ totais.total | number }}</span>
                                <span class="stat-lbl">eleitores</span>
                            </span>
                        </div>
                    </div>
                </app-card-content>
            </div>
        }

        @if (carregando) {
            <div class="uf-grid">
                @for (s of skeletons; track s) {
                    <p-skeleton width="100%" height="11rem" />
                }
            </div>
        } @else if (participacao.length) {
            <div class="uf-grid">
                @for (l of participacao; track l.ufSgUf) {
                    <div class="card-entrada card-entrada-1">
                        <app-card-content [border]="false" [title]="l.ufSgUf" [subtitle]="percentualParticipacao(l) + ' de participação'" icon="pi pi-flag">
                            <div class="participacao-card-corpo">
                                <div class="barra-segmentada" aria-hidden="true">
                                    <div class="seg seg-v" [style.width.%]="segmento(l.votantes, l.total)"></div>
                                    <div class="seg seg-n" [style.width.%]="segmento(l.naoVotantes, l.total)"></div>
                                    <div class="seg seg-j" [style.width.%]="segmento(l.justificados, l.total)"></div>
                                </div>

                                <div class="uf-cats">
                                    <button type="button" class="cat cat-v" (click)="abrirDrill(l.ufSgUf, 'V')">
                                        <span class="pontinho"></span>
                                        <span class="cat-lbl">Votantes</span>
                                        <span class="cat-num">{{ l.votantes | number }}</span>
                                        <i class="pi pi-chevron-right"></i>
                                    </button>
                                    <button type="button" class="cat cat-n" (click)="abrirDrill(l.ufSgUf, 'N')">
                                        <span class="pontinho"></span>
                                        <span class="cat-lbl">Não votantes</span>
                                        <span class="cat-num">{{ l.naoVotantes | number }}</span>
                                        <i class="pi pi-chevron-right"></i>
                                    </button>
                                    <button type="button" class="cat cat-j" (click)="abrirDrill(l.ufSgUf, 'J')">
                                        <span class="pontinho"></span>
                                        <span class="cat-lbl">Justificados</span>
                                        <span class="cat-num">{{ l.justificados | number }}</span>
                                        <i class="pi pi-chevron-right"></i>
                                    </button>
                                </div>

                                <div class="uf-card-foot">
                                    <span>Total de eleitores</span>
                                    <span class="uf-total">{{ l.total | number }}</span>
                                </div>
                            </div>
                        </app-card-content>
                    </div>
                }
            </div>
        } @else {
            <div class="vazio">Sem dados para o pleito e filtros selecionados.</div>
        }
    }
</ng-template>
